export const ApiLevels = [
  Object.freeze({
    id: "Information",
    name: "Information",
    bgColor: "#00b3e3",
    color: "#ffffff",
  }),
  Object.freeze({
    id: "Warning",
    name: "Warning",
    bgColor: "#f3be48",
    color: "#ffffff",
  }),
  Object.freeze({
    id: "Error",
    name: "Error",
    bgColor: "#fc5474",
    color: "#ffffff",
  }),
  Object.freeze({
    id: "Success",
    name: "Success",
    bgColor: "#2fbbac",
    color: "#ffffff",
  }),
];

export const ApiLevelsFilter = [
  Object.freeze({
    id: "",
    name: "All",
  }),
  ...ApiLevels,
];

export const getApiLevelsIdByName = (ApiLevelsName) => {
  return (
    ApiLevels.find((ApiLevels) => ApiLevels.name === ApiLevelsName)?.id ||
    ""
  );
};

export const getApiLevelsName = (ApiLevelsValue) => {
  return (
    ApiLevels.find(
      (ApiLevels) => ApiLevels.id === ApiLevelsValue.toString()
    )?.name || ""
  );
};

export const getApiLevelsById = (id) => {
  return ApiLevels.find((ApiLevels) => ApiLevels.id === id) || "";
};
